import * as React from 'react';
import * as ReactDOM from 'react-dom';

const Portal = ({ children }: { children: React.ReactNode }) => {
  const [modalContainer] = React.useState(document.createElement('div'));
  // prettier-ignore
  React.useEffect(() => {
    // Find the root element in your DOM
    let modalRoot = document.getElementById('modal-root');
    // Append modal container to root
    if (modalRoot) {
      modalRoot.appendChild(modalContainer);
    }
    return function cleanup() {
      // On cleanup remove the modal container
      if (modalRoot) {
        modalRoot.removeChild(modalContainer);
      }
    };

  },              []); // <- The empty array tells react to apply the effect on mount/unmount

  return ReactDOM.createPortal(children, modalContainer);
};

export default Portal;



// WEBPACK FOOTER //
// ./src/components/Portal.tsx